// extracted by mini-css-extract-plugin
export default {"container":"---------packages-corgi-x-src-components-ScrollSnap-ScrollSnap-module__container","item":"---------packages-corgi-x-src-components-ScrollSnap-ScrollSnap-module__item"};